import { render, staticRenderFns } from "./fahuo.vue?vue&type=template&id=eb89402e&scoped=true"
import script from "./fahuo.vue?vue&type=script&lang=js"
export * from "./fahuo.vue?vue&type=script&lang=js"
import style0 from "./fahuo.vue?vue&type=style&index=0&id=eb89402e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb89402e",
  null
  
)

export default component.exports